"use strict";

class bb_archivEngine {
  constructor() {
    document.addEventListener("DOMContentLoaded", this.afterDOMConstructor.bind(this));
  }

  afterDOMConstructor() {
    this.headlineElement = document.getElementById("bbArchivHeadline");
    this.bbArchivCounter = document.getElementById("bbArchivCounter");
    this.fullTextSearchInput = document.getElementById("bbArchivFullTextSearchInput");
    this.titleSearchInput = document.getElementById("bbArchivTitleSearchInput");
    this.titleSearchSelector = document.getElementById("bbArchivTitleSearchSelector");
    this.descriptionSearchInput = document.getElementById("bbArchivDescriptionSearchInput");
    this.descriptionSearchSelector = document.getElementById("bbArchivDescriptionSearchSelector");
    this.contributorSearchInput = document.getElementById("bbArchivContributorSearchInput");
    this.contributorSearchSelector = document.getElementById("bbArchivContributorSearchSelector");
    this.creatorSearchInput = document.getElementById("bbArchivCreatorSearchInput");
    this.creatorSearchSelector = document.getElementById("bbArchivCreatorSearchSelector");
    this.searchButton = document.getElementById("bbArchivSearchButton");
    this.filterTotalElement = document.getElementById("bbArchivFilterTotalElement");
    this.filterSortBy = document.getElementById("bbArchivFilterSortBy");
    this.filterButton = document.getElementById("bbArchivFilterApply");
    this.resultContainer = document.getElementById("bbArchivResultContainer");
    this.changeViewGridButton = document.getElementById("bbArchivFilterViewGrid");
    this.changeViewListButton = document.getElementById("bbArchivFilterViewList");
    this.languageDropdownButton = document.getElementById("bbArchivLanguageButton");
    this.languageDropdownBody = document.getElementById("bbArchivLanguageDropdown");
    this.languageWrapper = document.getElementById("bbArchivFilterLanguage");
    this.filterLanguageGerman = document.getElementById("languageGerman");
    this.filterLanguageEnglish = document.getElementById("languageEnglish");
    this.filterLanguageSpain = document.getElementById("languageSpain");
    this.filterLanguagePortuguese = document.getElementById("languagePortuguese");
    this.filterLanguageTurkish = document.getElementById("languageTurkish");
    this.filterMediaTypesImage = document.getElementById("mediaTypesImage");
    this.filterMediaTypesVideo = document.getElementById("mediaTypesVideo");
    this.filterMediaTypesAudio = document.getElementById("mediaTypesAudio");
    this.filterMediaTypesText = document.getElementById("mediaTypesText");
    this.filterMediaTypesVarious = document.getElementById("mediaTypesVarious");
    this.paginationTotalPages;
    this.paginationRow = document.querySelector("#bbArchivPagationRow");
    this.paginationLinkContainer = document.getElementById("paginationPageLinksInnerWrapper");
    this.searchButton.addEventListener("click", this.useSearch.bind(this));
    this.filterButton.addEventListener("click", this.applyFilter.bind(this));
    this.paginationRow.addEventListener("click", this.usePagination.bind(this));
    this.changeViewGridButton.addEventListener("click", this.changeViewGrid.bind(this));
    this.changeViewListButton.addEventListener("click", this.changeViewList.bind(this));
    document.body.addEventListener("click", this.closeDropdownOutside.bind(this));
    this.languageDropdownButton.addEventListener("click", this.toggleLanguageDropdown.bind(this));
    document.body.addEventListener(
      "keydown",
      function (event) {
        if (
          event.target === this.fullTextSearchInput ||
          event.target === this.titleSearchInput ||
          event.target === this.descriptionSearchInput ||
          event.target === this.contributorSearchInput ||
          event.target === this.creatorSearchInput
        ) {
          if (event.key === "Enter") {
            this.useSearch();
          }
        }
      }.bind(this)
    );
    this.firstLoad();
  }

  firstLoad() {
    let currentUrl = new URL(window.location.toString());
    let currentParams = new URLSearchParams(currentUrl.search);

    // Set default options according to the UI if no Params else Set UI according to Params

    if (!currentParams.has("per_page")) {
      currentUrl.searchParams.set("per_page", "12");
    } else {
      let options = this.filterTotalElement.querySelectorAll("option");
      options.forEach(
        function (element) {
          if (element.value === currentParams.get("per_page")) {
            element.selected = true;
          }
        }.bind(this)
      );
    }

    if (!currentParams.has("sort_by")) {
      currentUrl.searchParams.set("sort_by", "created");
    }

    if (!currentParams.has("sort_order")) {
      currentUrl.searchParams.set("sort_order", "desc");
    } else {
      let options = this.filterSortBy.querySelectorAll("option");
      options.forEach(
        function (element) {
          if (element.value === currentParams.get("sort_order")) {
            element.selected = true;
          }
        }.bind(this)
      );
    }

    // Set Ui Language according to Url Params

    if (
      currentUrl.searchParams.has("property[10][joiner]") &&
      currentUrl.searchParams.has("property[10][property]") &&
      currentUrl.searchParams.has("property[10][type]") &&
      currentUrl.searchParams.has("property[10][text]")
    ) {
      this.filterLanguageGerman.checked = false;
    }

    if (
      currentUrl.searchParams.has("property[11][joiner]") &&
      currentUrl.searchParams.has("property[11][property]") &&
      currentUrl.searchParams.has("property[11][type]") &&
      currentUrl.searchParams.has("property[11][text]")
    ) {
      this.filterLanguageSpain.checked = false;
    }

    if (
      currentUrl.searchParams.has("property[12][joiner]") &&
      currentUrl.searchParams.has("property[12][property]") &&
      currentUrl.searchParams.has("property[12][type]") &&
      currentUrl.searchParams.has("property[12][text]")
    ) {
      this.filterLanguagePortuguese.checked = false;
    }

    if (
      currentUrl.searchParams.has("property[13][joiner]") &&
      currentUrl.searchParams.has("property[13][property]") &&
      currentUrl.searchParams.has("property[13][type]") &&
      currentUrl.searchParams.has("property[13][text]")
    ) {
      this.filterLanguageTurkish.checked = false;
    }

    if (
      currentUrl.searchParams.has("property[14][joiner]") &&
      currentUrl.searchParams.has("property[14][property]") &&
      currentUrl.searchParams.has("property[14][type]") &&
      currentUrl.searchParams.has("property[14][text]")
    ) {
      this.filterLanguageEnglish.checked = false;
    }

    // Set UI Media Types according to URl Params

    if (
      (!currentUrl.searchParams.has("media_types[0]") ||
        !currentUrl.searchParams.has("media_types[1]") ||
        !currentUrl.searchParams.has("media_types[2]") ||
        !currentUrl.searchParams.has("media_types[3]") ||
        !currentUrl.searchParams.has("media_types[4]") ||
        !currentUrl.searchParams.has("media_types[5]") ||
        !currentUrl.searchParams.has("media_types[6]") ||
        !currentUrl.searchParams.has("media_types[7]")) &&
      currentUrl.searchParams.has("has_media")
    ) {
      this.filterMediaTypesImage.checked = false;
    }

    if (
      (!currentUrl.searchParams.has("media_types[27]") ||
        !currentUrl.searchParams.has("media_types[28]") ||
        !currentUrl.searchParams.has("media_types[29]") ||
        !currentUrl.searchParams.has("media_types[30]") ||
        !currentUrl.searchParams.has("media_types[31]") ||
        !currentUrl.searchParams.has("media_types[32]")) &&
      currentUrl.searchParams.has("has_media")
    ) {
      this.filterMediaTypesVarious.checked = false;
    }

    if (
      (!currentUrl.searchParams.has("media_types[33]") ||
        !currentUrl.searchParams.has("media_types[34]") ||
        !currentUrl.searchParams.has("media_types[35]") ||
        !currentUrl.searchParams.has("media_types[36]") ||
        !currentUrl.searchParams.has("media_types[37]") ||
        !currentUrl.searchParams.has("media_types[38]") ||
        !currentUrl.searchParams.has("media_types[39]") ||
        !currentUrl.searchParams.has("media_types[41]") ||
        !currentUrl.searchParams.has("media_types[42]") ||
        !currentUrl.searchParams.has("media_types[43]") ||
        !currentUrl.searchParams.has("media_types[9]")) &&
      currentUrl.searchParams.has("has_media")
    ) {
      this.filterMediaTypesAudio.checked = false;
    }

    if (
      (!currentUrl.searchParams.has("media_types[44]") ||
        !currentUrl.searchParams.has("media_types[45]") ||
        !currentUrl.searchParams.has("media_types[46]") ||
        !currentUrl.searchParams.has("media_types[10]") ||
        !currentUrl.searchParams.has("media_types[11]") ||
        !currentUrl.searchParams.has("media_types[8]") ||
        !currentUrl.searchParams.has("media_types[12]") ||
        !currentUrl.searchParams.has("media_types[13]") ||
        !currentUrl.searchParams.has("media_types[14]") ||
        !currentUrl.searchParams.has("media_types[15]") ||
        !currentUrl.searchParams.has("media_types[16]") ||
        !currentUrl.searchParams.has("media_types[17]") ||
        !currentUrl.searchParams.has("media_types[18]") ||
        !currentUrl.searchParams.has("media_types[19]") ||
        !currentUrl.searchParams.has("media_types[20]") ||
        !currentUrl.searchParams.has("media_types[21]") ||
        !currentUrl.searchParams.has("media_types[22]") ||
        !currentUrl.searchParams.has("media_types[23]") ||
        !currentUrl.searchParams.has("media_types[24]") ||
        !currentUrl.searchParams.has("media_types[25]") ||
        !currentUrl.searchParams.has("media_types[26]")) &&
      currentUrl.searchParams.has("has_media")
    ) {
      this.filterMediaTypesText.checked = false;
    }

    if (
      (!currentUrl.searchParams.has("media_types[47]") ||
        !currentUrl.searchParams.has("media_types[48]") ||
        !currentUrl.searchParams.has("media_types[49]") ||
        !currentUrl.searchParams.has("media_types[50]") ||
        !currentUrl.searchParams.has("media_types[51]") ||
        !currentUrl.searchParams.has("media_types[52]") ||
        !currentUrl.searchParams.has("media_types[53]") ||
        !currentUrl.searchParams.has("media_types[54]") ||
        !currentUrl.searchParams.has("media_types[55]")) &&
      currentUrl.searchParams.has("has_media")
    ) {
      this.filterMediaTypesVideo.checked = false;
    }

    if (!currentParams.has("currentPage")) {
      currentUrl.searchParams.set("currentPage", 1);
    }

    // Set UI Search According to Url Params

    if (currentParams.has("property[0][text]")) {
      this.fullTextSearchInput.value = currentParams.get("property[0][text]");
      this.headlineElement.textContent = "Suchergebnisse";
    }

    if (currentParams.has("property[1][text]")) {
      this.titleSearchInput.value = currentParams.get("property[1][text]");
      let AdvancedSearch = document.getElementById("bbArchivAdvancedSearch");
      AdvancedSearch.classList.add("bb-collapsed");
      this.headlineElement.textContent = "Suchergebnisse";
      if (currentParams.has("property[1][type]")) {
        let options = this.titleSearchSelector.querySelectorAll("option");
        options.forEach(
          function (element) {
            if (element.value === currentParams.get("property[1][type]")) {
              element.selected = true;
            }
          }.bind(this)
        );
      }
    }

    if (currentParams.has("property[2][text]")) {
      this.descriptionSearchInput.value = currentParams.get("property[2][text]");
      let AdvancedSearch = document.getElementById("bbArchivAdvancedSearch");
      AdvancedSearch.classList.add("bb-collapsed");
      this.headlineElement.textContent = "Suchergebnisse";
    }

    if (currentParams.has("property[3][text]")) {
      this.contributorSearchInput.value = currentParams.get("property[3][text]");
      let AdvancedSearch = document.getElementById("bbArchivAdvancedSearch");
      AdvancedSearch.classList.add("bb-collapsed");
      this.headlineElement.textContent = "Suchergebnisse";
    }

    if (currentParams.has("property[4][text]")) {
      this.creatorSearchInput.value = currentParams.get("property[4][text]");
      let AdvancedSearch = document.getElementById("bbArchivAdvancedSearch");
      AdvancedSearch.classList.add("bb-collapsed");
      this.headlineElement.textContent = "Suchergebnisse";
    }

    if (currentParams.has("item_set_id[0]")) {
      let itemSetId = currentParams.get("item_set_id[0]");
      fetch(`https://coronarchiv.geschichte.uni-hamburg.de/projector/api/item_sets/${itemSetId}`)
        .then((response) => response.json())
        .then((data) => {
          this.headlineElement.textContent = data["dcterms:title"][0]["@value"];
        });
    }

    window.history.pushState({}, "", currentUrl);
    currentUrl.searchParams.set("page", currentUrl.searchParams.get("currentPage"));
    currentUrl.searchParams.delete("currentPage");

    let httpHeader = {};
    let request = new Request(api_itemURLClean + currentUrl.search, {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    document.body.style.cursor = "wait";
    this.resultContainer.innerHTML =
      "<div class='bb-archiv-load-wrapper'><div class='bb-archiv-loader'><div></div><div></div><div></div><div></div></div></div>";

    omekaAPI.getItemOnly(request).then(
      function (data) {
        document.body.style.cursor = "default";
        this.currentData = data;
        this.renderNow();
        this.refreshPagination();
      }.bind(this)
    );
  }

  applyFilter() {
    let currentUrl = new URL(window.location.toString());
    let currentParams = new URLSearchParams(currentUrl.search);
    let oldParams = currentUrl.search;

    let oldTotal = +this.filterTotalElement.options[this.filterTotalElement.selectedIndex].value;
    let newTotal = +currentUrl.searchParams.get("per_page");
    if (oldTotal !== newTotal) {
      currentUrl.searchParams.set(
        "per_page",
        this.filterTotalElement.options[this.filterTotalElement.selectedIndex].value
      );
    }

    let oldSortBy = this.filterSortBy.options[this.filterSortBy.selectedIndex].value;
    let newSortBy = currentUrl.searchParams.get("sort_order");
    if (oldSortBy !== newSortBy) {
      currentUrl.searchParams.set("sort_order", this.filterSortBy.options[this.filterSortBy.selectedIndex].value);
    }

    // LANGUAGE FILTER

    if (!this.filterLanguageGerman.checked) {
      currentUrl.searchParams.set("property[10][joiner]", "and");
      currentUrl.searchParams.set("property[10][property]", 12);
      currentUrl.searchParams.set("property[10][type]", "neq");
      currentUrl.searchParams.set("property[10][text]", "de");
    } else {
      currentUrl.searchParams.delete("property[10][joiner]");
      currentUrl.searchParams.delete("property[10][property]");
      currentUrl.searchParams.delete("property[10][type]");
      currentUrl.searchParams.delete("property[10][text]");
    }

    if (!this.filterLanguageEnglish.checked) {
      currentUrl.searchParams.set("property[11][joiner]", "and");
      currentUrl.searchParams.set("property[11][property]", 12);
      currentUrl.searchParams.set("property[11][type]", "neq");
      currentUrl.searchParams.set("property[11][text]", "en");
    } else {
      currentUrl.searchParams.delete("property[11][joiner]");
      currentUrl.searchParams.delete("property[11][property]");
      currentUrl.searchParams.delete("property[11][type]");
      currentUrl.searchParams.delete("property[11][text]");
    }

    if (!this.filterLanguageSpain.checked) {
      currentUrl.searchParams.set("property[12][joiner]", "and");
      currentUrl.searchParams.set("property[12][property]", 12);
      currentUrl.searchParams.set("property[12][type]", "neq");
      currentUrl.searchParams.set("property[12][text]", "es");
    } else {
      currentUrl.searchParams.delete("property[12][joiner]");
      currentUrl.searchParams.delete("property[12][property]");
      currentUrl.searchParams.delete("property[12][type]");
      currentUrl.searchParams.delete("property[12][text]");
    }

    if (!this.filterLanguagePortuguese.checked) {
      currentUrl.searchParams.set("property[13][joiner]", "and");
      currentUrl.searchParams.set("property[13][property]", 12);
      currentUrl.searchParams.set("property[13][type]", "neq");
      currentUrl.searchParams.set("property[13][text]", "pt-pt");
    } else {
      currentUrl.searchParams.delete("property[13][joiner]");
      currentUrl.searchParams.delete("property[13][property]");
      currentUrl.searchParams.delete("property[13][type]");
      currentUrl.searchParams.delete("property[13][text]");
    }

    if (!this.filterLanguageTurkish.checked) {
      currentUrl.searchParams.set("property[14][joiner]", "and");
      currentUrl.searchParams.set("property[14][property]", 12);
      currentUrl.searchParams.set("property[14][type]", "neq");
      currentUrl.searchParams.set("property[14][text]", "tr");
    } else {
      currentUrl.searchParams.delete("property[14][joiner]");
      currentUrl.searchParams.delete("property[14][property]");
      currentUrl.searchParams.delete("property[14][type]");
      currentUrl.searchParams.delete("property[14][text]");
    }

    // MEDIA FILTER

    if (
      !this.filterMediaTypesImage.checked &&
      !this.filterMediaTypesVideo.checked &&
      !this.filterMediaTypesAudio.checked &&
      !this.filterMediaTypesText.checked &&
      !this.filterMediaTypesVarious.checked
    ) {
      currentUrl.searchParams.set("has_media", 0);
    } else {
      currentUrl.searchParams.set("has_media", "");
    }

    if (
      !this.filterMediaTypesImage.checked ||
      !this.filterMediaTypesVideo.checked ||
      !this.filterMediaTypesAudio.checked ||
      !this.filterMediaTypesText.checked ||
      !this.filterMediaTypesVarious.checked
    ) {
      /*
      if (this.filterMediaTypesImage.checked) {
        currentUrl.searchParams.set("item_set_id[0]", "7596");
      } else {
        currentUrl.searchParams.delete("item_set_id[0]");
      }

      if (this.filterMediaTypesVideo.checked) {
        currentUrl.searchParams.set("item_set_id[1]", "7596");
      } else {
        currentUrl.searchParams.delete("item_set_id[1]");
      }

      if (this.filterMediaTypesAudio.checked) {
        currentUrl.searchParams.set("item_set_id[2]", "7596");
      } else {
        currentUrl.searchParams.delete("item_set_id[2]");
      }

      if (this.filterMediaTypesText.checked) {
        currentUrl.searchParams.set("item_set_id[3]", "7596");
      } else {
        currentUrl.searchParams.delete("item_set_id[3]");
      }

      if (this.filterMediaTypesImage.checked) {
        currentUrl.searchParams.set("item_set_id[4]", "7596");
      } else {
        currentUrl.searchParams.delete("item_set_id[4]");
      }
      */

      if (this.filterMediaTypesImage.checked) {
        currentUrl.searchParams.set("media_types[0]", "image/jpeg");
        currentUrl.searchParams.set("media_types[1]", "image/pjpeg");
        currentUrl.searchParams.set("media_types[2]", "image/png");
        currentUrl.searchParams.set("media_types[3]", "image/bmp");
        currentUrl.searchParams.set("media_types[4]", "image/gif");
        currentUrl.searchParams.set("media_types[5]", "image/jp2");
        currentUrl.searchParams.set("media_types[6]", "image/tiff");
        currentUrl.searchParams.set("media_types[7]", "image/x-icon");
      } else {
        for (let i = 0; i < 8; i++) {
          currentUrl.searchParams.delete(`media_types[${i}]`);
        }
      }

      if (this.filterMediaTypesVarious.checked) {
        currentUrl.searchParams.set("media_types[27]", "application/x-gzip");
        currentUrl.searchParams.set("media_types[28]", "application/x-ms-wmp");
        currentUrl.searchParams.set("media_types[29]", "application/x-msdownload");
        currentUrl.searchParams.set("media_types[30]", "application/x-shockwave-flash");
        currentUrl.searchParams.set("media_types[31]", "application/x-tar");
        currentUrl.searchParams.set("media_types[32]", "application/zip");
      } else {
        for (let i = 27; i < 33; i++) {
          currentUrl.searchParams.delete(`media_types[${i}]`);
        }
      }

      if (this.filterMediaTypesAudio.checked) {
        currentUrl.searchParams.set("media_types[33]", "audio/midi");
        currentUrl.searchParams.set("media_types[34]", "audio/mp4");
        currentUrl.searchParams.set("media_types[35]", "audio/mpeg");
        currentUrl.searchParams.set("media_types[36]", "audio/ogg");
        currentUrl.searchParams.set("media_types[37]", "audio/x-aac");
        currentUrl.searchParams.set("media_types[38]", "audio/x-aiff");
        currentUrl.searchParams.set("media_types[39]", "audio/x-ms-wma");
        currentUrl.searchParams.set("media_types[41]", "audio/x-ms-wax");
        currentUrl.searchParams.set("media_types[42]", "audio/x-realaudio");
        currentUrl.searchParams.set("media_types[43]", "audio/x-wav");
        currentUrl.searchParams.set("media_types[9]", "application/ogg");
      } else {
        for (let i = 33; i < 44; i++) {
          currentUrl.searchParams.delete(`media_types[${i}]`);
        }
        currentUrl.searchParams.delete("media_types[9]");
      }

      if (this.filterMediaTypesText.checked) {
        currentUrl.searchParams.set("media_types[44]", "text/css");
        currentUrl.searchParams.set("media_types[45]", "text/plain");
        currentUrl.searchParams.set("media_types[46]", "text/richtext");
        currentUrl.searchParams.set("media_types[10]", "application/pdf");
        currentUrl.searchParams.set("media_types[11]", "application/rtf");
        currentUrl.searchParams.set("media_types[8]", "application/msword");
        currentUrl.searchParams.set("media_types[12]", "application/vnd.ms-access");
        currentUrl.searchParams.set("media_types[13]", "application/vnd.ms-excel");
        currentUrl.searchParams.set("media_types[14]", "application/vnd.ms-powerpoint");
        currentUrl.searchParams.set("media_types[15]", "application/vnd.ms-project");
        currentUrl.searchParams.set("media_types[16]", "application/vnd.ms-write");
        currentUrl.searchParams.set("media_types[17]", "application/vnd.oasis.opendocument.chart");
        currentUrl.searchParams.set("media_types[18]", "application/vnd.oasis.opendocument.database");
        currentUrl.searchParams.set("media_types[19]", "application/vnd.oasis.opendocument.formula");
        currentUrl.searchParams.set("media_types[20]", "application/vnd.oasis.opendocument.graphics");
        currentUrl.searchParams.set("media_types[21]", "application/vnd.oasis.opendocument.presentation");
        currentUrl.searchParams.set("media_types[22]", "application/vnd.oasis.opendocument.spreadsheet");
        currentUrl.searchParams.set("media_types[23]", "application/vnd.oasis.opendocument.text");
        currentUrl.searchParams.set(
          "media_types[24]",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        );
        currentUrl.searchParams.set(
          "media_types[25]",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        );
        currentUrl.searchParams.set(
          "media_types[26]",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      } else {
        for (let i = 12; i < 27; i++) {
          currentUrl.searchParams.delete(`media_types[${i}]`);
        }
        currentUrl.searchParams.delete("media_types[44]");
        currentUrl.searchParams.delete("media_types[45]");
        currentUrl.searchParams.delete("media_types[46]");
        currentUrl.searchParams.delete("media_types[10]");
        currentUrl.searchParams.delete("media_types[11]");
        currentUrl.searchParams.delete("media_types[8]");
      }

      if (this.filterMediaTypesVideo.checked) {
        currentUrl.searchParams.set("media_types[47]", "video/divx");
        currentUrl.searchParams.set("media_types[48]", "video/mp4");
        currentUrl.searchParams.set("media_types[49]", "video/mpeg");
        currentUrl.searchParams.set("media_types[50]", "video/ogg");
        currentUrl.searchParams.set("media_types[51]", "video/quicktime");
        currentUrl.searchParams.set("media_types[52]", "video/webm");
        currentUrl.searchParams.set("media_types[53]", "video/x-ms-asf");
        currentUrl.searchParams.set("media_types[54]", "video/x-msvideo");
        currentUrl.searchParams.set("media_types[55]", "video/x-ms-wmv");
      } else {
        for (let i = 47; i < 56; i++) {
          currentUrl.searchParams.delete(`media_types[${i}]`);
        }
      }
    } else {
      currentUrl.searchParams.delete("has_media");
      for (let i = 0; i < 56; i++) {
        currentUrl.searchParams.delete(`media_types[${i}]`);
      }
    }

    if (oldParams === currentUrl.search) {
      return;
    }

    window.history.pushState({}, "", currentUrl);
    currentUrl.searchParams.set("page", currentUrl.searchParams.get("currentPage"));
    currentUrl.searchParams.delete("currentPage");

    let httpHeader = {};
    let request = new Request(api_itemURLClean + currentUrl.search, {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    document.body.style.cursor = "wait";
    this.resultContainer.innerHTML =
      "<div class='bb-archiv-load-wrapper'><div class='bb-archiv-loader'><div></div><div></div><div></div><div></div></div></div>";
    omekaAPI.getItemOnly(request).then(
      function (data) {
        document.body.style.cursor = "default";
        this.currentData = data;
        this.renderNow();
        this.refreshPagination();
      }.bind(this)
    );
  }

  useSearch() {
    let currentUrl = new URL(window.location.toString());
    let currentParams = new URLSearchParams(currentUrl.search);
    let oldParams = currentUrl.search;

    let fullTextSearchInput = this.fullTextSearchInput.value;
    let titleSearchInput = this.titleSearchInput.value;
    let titleSearchSelector = this.titleSearchSelector.value;
    let descriptionSearchInput = this.descriptionSearchInput.value;
    let descriptionSearchSelector = this.descriptionSearchSelector.value;
    let contributorSearchInput = this.contributorSearchInput.value;
    let contributorSearchSelector = this.contributorSearchSelector.value;
    let creatorSearchInput = this.creatorSearchInput.value;
    let creatorSearchSelector = this.creatorSearchSelector.value;

    if (fullTextSearchInput != "") {
      currentUrl.searchParams.set("property[0][joiner]", "and");
      currentUrl.searchParams.set("property[0][property]", "");
      currentUrl.searchParams.set("property[0][type]", "in");
      currentUrl.searchParams.set("property[0][text]", fullTextSearchInput);
    } else {
      currentUrl.searchParams.delete("property[0][joiner]");
      currentUrl.searchParams.delete("property[0][property]");
      currentUrl.searchParams.delete("property[0][type]");
      currentUrl.searchParams.delete("property[0][text]");
    }

    if (titleSearchInput != "") {
      currentUrl.searchParams.set("property[1][joiner]", "and");
      currentUrl.searchParams.set("property[1][property]", 1);
      currentUrl.searchParams.set("property[1][type]", titleSearchSelector);
      currentUrl.searchParams.set("property[1][text]", titleSearchInput);
    } else {
      currentUrl.searchParams.delete("property[1][joiner]");
      currentUrl.searchParams.delete("property[1][property]");
      currentUrl.searchParams.delete("property[1][type]");
      currentUrl.searchParams.delete("property[1][text]");
    }

    if (descriptionSearchInput != "") {
      currentUrl.searchParams.set("property[2][joiner]", "and");
      currentUrl.searchParams.set("property[2][property]", 4);
      currentUrl.searchParams.set("property[2][type]", descriptionSearchSelector);
      currentUrl.searchParams.set("property[2][text]", descriptionSearchInput);
    } else {
      currentUrl.searchParams.delete("property[2][joiner]");
      currentUrl.searchParams.delete("property[2][property]");
      currentUrl.searchParams.delete("property[2][type]");
      currentUrl.searchParams.delete("property[2][text]");
    }

    if (contributorSearchInput != "") {
      currentUrl.searchParams.set("property[3][joiner]", "and");
      currentUrl.searchParams.set("property[3][property]", 6);
      currentUrl.searchParams.set("property[3][type]", contributorSearchSelector);
      currentUrl.searchParams.set("property[3][text]", contributorSearchInput);
    } else {
      currentUrl.searchParams.delete("property[3][joiner]");
      currentUrl.searchParams.delete("property[3][property]");
      currentUrl.searchParams.delete("property[3][type]");
      currentUrl.searchParams.delete("property[3][text]");
    }

    if (creatorSearchInput != "") {
      currentUrl.searchParams.set("property[4][joiner]", "and");
      currentUrl.searchParams.set("property[4][property]", 2);
      currentUrl.searchParams.set("property[4][type]", creatorSearchSelector);
      currentUrl.searchParams.set("property[4][text]", creatorSearchInput);
    } else {
      currentUrl.searchParams.delete("property[4][joiner]");
      currentUrl.searchParams.delete("property[4][property]");
      currentUrl.searchParams.delete("property[4][type]");
      currentUrl.searchParams.delete("property[4][text]");
    }

    if (oldParams === currentUrl.search) {
      return;
    }

    this.headlineElement.textContent = "Suchergebnisse";
    currentUrl.searchParams.set("currentPage", 1);

    window.history.pushState({}, "", currentUrl);
    currentUrl.searchParams.set("page", "1");
    currentUrl.searchParams.delete("currentPage");

    let httpHeader = {};
    let request = new Request(api_itemURLClean + currentUrl.search, {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    document.body.style.cursor = "wait";
    this.resultContainer.innerHTML =
      "<div class='bb-archiv-load-wrapper'><div class='bb-archiv-loader'><div></div><div></div><div></div><div></div></div></div>";
    omekaAPI.getItemOnly(request).then(
      function (data) {
        document.body.style.cursor = "default";
        this.currentData = data;
        this.renderNow();
        this.refreshPagination();
      }.bind(this)
    );
  }

  refreshPagination() {
    let currentUrl = new URL(window.location.toString());
    let currentParams = new URLSearchParams(currentUrl.search);
    let httpHeader = {};
    let request = new Request(api_infoURLClean + currentUrl.search, {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    omekaAPI.getTotalItems(request).then(
      function (totalItems) {
        this.bbArchivCounter.textContent = `(${totalItems})`;

        let currentUrl = new URL(window.location);
        let currentParams = new URLSearchParams(currentUrl.search);
        let currentPage = currentParams.get("currentPage");
        let pageSize = currentParams.get("per_page");

        const pagination = {};
        pagination.totalPages = Math.ceil(totalItems / pageSize);
        pagination.pages = [+currentPage];
        this.paginationTotalPages = pagination.totalPages;

        let maxPages;
        if (pagination.totalPages > 9) {
          maxPages = 9;
        } else {
          maxPages = pagination.totalPages;
        }
        let counterLeft = 1;
        let counterRight = 1;
        for (let i = 1; i < maxPages; ) {
          if (+currentPage + counterRight <= pagination.totalPages) {
            pagination.pages.push(+currentPage + counterRight);
            counterRight++;
            i++;
          }
          if (+currentPage - counterLeft >= 1) {
            pagination.pages.unshift(+currentPage - counterLeft);
            counterLeft++;
            i++;
          }
        }

        if (!pagination.pages) {
          return;
        }

        this.paginationLinkContainer.innerHTML = "";
        let template = document.getElementById("paginationPageLinksTemplate");
        pagination.pages.forEach(
          function (element, index) {
            if (index >= 11) {
              return;
            }
            template.content.querySelector("a").textContent = element;
            template.content.querySelector("a").value = element;
            let clone = document.importNode(template.content, true);
            this.paginationLinkContainer.appendChild(clone);
          }.bind(this)
        );

        this.paginationLinkContainer.querySelectorAll("li").forEach(
          function (element) {
            element.classList.remove("paginationCurrentPage");
            if (element.textContent == currentPage) {
              element.classList.add("paginationCurrentPage");
            }
          }.bind(this)
        );
      }.bind(this)
    );
  }

  usePagination(event) {
    let currentUrl = new URL(window.location);
    let currentParams = new URLSearchParams(currentUrl.search);
    let pageToSet;

    if (event.target.id === "paginationBack") {
      pageToSet = Number(currentParams.get("currentPage")) - 1;

      if (pageToSet > 0) {
        currentUrl.searchParams.set("currentPage", pageToSet);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        return;
      }
    }

    if (event.target.id === "paginationForward") {
      if (!currentParams.has("currentPage")) {
        pageToSet = 2;
        currentUrl.searchParams.set("currentPage", 2);
      }
      pageToSet = Number(currentParams.get("currentPage")) + 1;

      if (pageToSet < this.paginationTotalPages) {
        currentUrl.searchParams.set("currentPage", pageToSet);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        return;
      }
    }

    if (event.target.localName === "a") {
      pageToSet = event.target.textContent;
      currentUrl.searchParams.set("currentPage", event.target.textContent);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    window.history.pushState({}, "", currentUrl);
    currentParams.set("page", pageToSet);
    currentParams.delete("currentPage");

    let httpHeader = {};
    let request = new Request(api_itemURL + currentParams.toString(), {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    document.body.style.cursor = "wait";
    this.resultContainer.innerHTML =
      "<div class='bb-archiv-load-wrapper'><div class='bb-archiv-loader'><div></div><div></div><div></div><div></div></div></div>";
    omekaAPI.getItemOnly(request).then(
      function (data) {
        document.body.style.cursor = "default";
        this.currentData = data;
        this.renderNow();
        this.refreshPagination();
      }.bind(this)
    );
  }

  renderNow() {
    let currentUrl = new URL(window.location);
    let currentParams = new URLSearchParams(currentUrl.search);

    this.resultContainer.innerHTML = "";
    let template = document.getElementById("bbArchivResultItemTemplate");
    this.currentData.forEach((element) => {
      let createdRaw = new Date(element["o:created"]["@value"]);
      let created =
        createdRaw.getUTCDate() +
        "." +
        (createdRaw.getUTCMonth() + 1) +
        "." +
        createdRaw.getUTCFullYear() +
        " um " +
        createdRaw.getUTCHours() +
        ":" +
        createdRaw.getUTCMinutes() +
        ":" +
        createdRaw.getUTCSeconds();

      let titleRaw = element["dcterms:title"][0]["@value"];
      let trimmedTitle;
      if (titleRaw.length > 110) {
        trimmedTitle = titleRaw.substring(0, 105) + " (...)";
      } else {
        trimmedTitle = titleRaw;
      }

      if (element["dcterms:description"]) {
        let descriptionRaw = element["dcterms:description"][0]["@value"];
        let trimmedDescription;
        if (descriptionRaw.length > 260) {
          trimmedDescription = descriptionRaw.substring(0, 255) + " (...)";
        } else {
          trimmedDescription = descriptionRaw;
        }
        template.content.querySelector("p").textContent = trimmedDescription;
      }

      console.log(element);

      if (!element["thumbnail_display_urls"]["square"]) {
        template.content.querySelector("img").src =
          "https://coronarchiv.geschichte.uni-hamburg.de/projector/application/asset/thumbnails/default.png";
      } else if (element["thumbnail_display_urls"]["square"].includes("?v=")) {
        let thumbnailUrl = omeka_baseURL.toString() + element["thumbnail_display_urls"]["square"];
        template.content.querySelector("img").src = thumbnailUrl;
      } else {
        template.content.querySelector("img").src = element["thumbnail_display_urls"]["square"];
      }

      template.content.querySelector("span").textContent = `Erstellt am ${created}`;
      template.content.querySelector("h2").textContent = trimmedTitle;
      let itemId = element["o:id"];

      let itemLinks = template.content.querySelectorAll("a");
      itemLinks.forEach((element) => {
        if (currentParams.has("lang")) {
          let langParam = currentParams.get("lang");
          element.href = `/item/?id=${itemId}&lang=${langParam}`;
        } else {
          element.href = `/item/?id=${itemId}`;
        }
      });

      let clone = document.importNode(template.content, true);
      this.resultContainer.appendChild(clone);
    });
  }

  changeViewGrid() {
    this.resultContainer.classList.remove("bb-archiv-listView");
    this.resultContainer.classList.add("bb-archiv-gridView");
    window.sessionStorage.setItem("view", "grid");
  }
  changeViewList() {
    this.resultContainer.classList.remove("bb-archiv-gridView");
    this.resultContainer.classList.add("bb-archiv-listView");
    window.sessionStorage.setItem("view", "list");
  }

  toggleLanguageDropdown() {
    this.languageDropdownBody.classList.toggle("opacity-0");
  }

  closeDropdownOutside(event) {
    if (this.languageDropdownBody.classList.contains("opacity-0")) {
      return;
    }
    if (!this.languageDropdownBody.classList.contains("opacity-0")) {
      if (!event.path.includes(this.languageWrapper)) {
        this.toggleLanguageDropdown();
      }
    }
  }
}

//TODO: DER PATHNAME WIRD SICH IN ANDEREN SPRACHEN ÄNDENR. ABER WILLST DU WARTEN BIS DER DOM GERENDERT WURDE?
let pathname = window.location.pathname;
const url_params = new URLSearchParams(window.location.search);

if (
  pathname.includes("/archiv/") ||
  pathname.includes("/arsivi/") ||
  pathname.includes("/archivo/") ||
  pathname.includes("/archive/")
) {
  const archiveEngine = new bb_archivEngine();
}
